import { FC } from 'react'
import { AccordionContent, SkeletonPaymentForm } from '@yuno/sdk-web-core/dist/ui'
import {
  Container,
  PaymentContent,
  PaymentMethod,
  PaymentMethodHeading,
  PaymentMethodName,
  PaymentMethodsContainer,
  PaymentScroll,
  Wrapper,
} from './payment-methods-desktop.styled'
import { usePaymentMethodsDesktop } from './use-payment-methods-desktop'
import { isFirstPaymentMethod } from '../payment-methods.utils'
import { PaymentStepHeading } from '../../payment-checkout.styled'
import { ButtonExternalContent, PaymentMethodsContent } from '../payment-methods.styled'
import { SecureCopy } from '../secure-copy'
import { useTranslation } from 'react-i18next'

export const PaymentMethodsDesktop: FC = () => {
  const {
    paymentMethods,
    onChangeAccordion,
    accordionSelected,
  } = usePaymentMethodsDesktop()
  const { t } = useTranslation()

  return (
    <Container>
      <PaymentScroll>
        <Wrapper>
          <PaymentMethodsContainer>
            <PaymentStepHeading>{t('Choose a payment method')}</PaymentStepHeading>
            <PaymentMethodsContent>
              {paymentMethods.map((paymentMethod, index) => {
                const isActive =
                  (accordionSelected === undefined &&
                    isFirstPaymentMethod(paymentMethod, index)) ||
                  accordionSelected === paymentMethod.type

                return (
                <PaymentMethod
                  key={paymentMethod.type}
                  onChange={onChangeAccordion}
                  data-active={isActive}
                >
                  <PaymentMethodHeading
                    id={`accordion-${paymentMethod.type}`}
                    ariaControls={`content-${paymentMethod.type}`}
                    open={isActive}
                  >
                    <img src={paymentMethod.icon} width={30} height={30} />{' '}
                    <PaymentMethodName>{paymentMethod.name}</PaymentMethodName>
                  </PaymentMethodHeading>
                  <AccordionContent
                    id={`content-${paymentMethod.type}`}
                    ariaLabelledBy={`accordion-${paymentMethod.type}`}
                  >
                    <div id={`root-${paymentMethod.type}`} />
                    <PaymentContent 
                      id={`root-content-${paymentMethod.type}`}>
                      <SkeletonPaymentForm />
                    </PaymentContent>
                  </AccordionContent>
                </PaymentMethod>
                )
              })}
              <div id="root-sdk"></div>

              <ButtonExternalContent>
                <div id="paypal"></div>
              </ButtonExternalContent>
            </PaymentMethodsContent>
            <SecureCopy />
          </PaymentMethodsContainer>
        </Wrapper>
      </PaymentScroll>
    </Container>
  )
}
